<template>
  <div class="act-rules">
    <div class="ttl">活动规则</div>
    <div class="rule_text">
      <div v-for="(item, index) in rules" :key="index" class="line">
        <span>{{ index + 1 }}. </span>
        {{ item.value }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rules: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="less" scoped>

.act-rules {
  box-sizing: border-box;
  // width: 347px;
  min-height: 183px;
  // padding: 20px;
  // margin: 40px 14px;
  background: rgba(255, 255, 255, 0.58);
  border-radius: 6px;
  // margin: 20px auto 0;

  .ttl {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: 600;
    line-height: 25px;
    text-align: center;
  }

  .line {
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

</style>
